import { GraphsData } from '@/api/workOrders/types';
import { Box, Divider, Typography } from '@mui/material';

import { GroupStatusIcon } from '../../components/StatusIndicators';
import { GraphTitle, StyledCardMedia } from '../../styles';
import { FAC_GRAPHS_FIELD_LABELS } from '../constants';

interface FactorsGraphsProps {
  graphs: GraphsData[];
}

export function FactorsGraphs({ graphs }: FactorsGraphsProps): JSX.Element {
  return (
    <Box id="fac-graphs">
      <Divider />
      <Box display="flex" alignItems="center" gap={1}>
        <GroupStatusIcon isComplete={graphs.length > 0} />
        <Typography my={3} fontWeight={600}>
          Análise gráfica
        </Typography>
      </Box>
      <GraphTitle>
        {FAC_GRAPHS_FIELD_LABELS.unit_land_prediction_power}
      </GraphTitle>
      {graphs.length > 0 ? (
        <Box width="400px" margin="0 auto">
          {graphs.map((graph) => (
            <Box key={graph.id} mb={4}>
              <StyledCardMedia image={graph.file_url} title={graph.title} />
            </Box>
          ))}
        </Box>
      ) : (
        <Typography color="text.secondary">-</Typography>
      )}
    </Box>
  );
}
